import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import EditDeleteButton from '../shared/buttons/EditDeleteButton';
import formatter from '../../utilities/formatter';
import postData from '../../utilities/postData';
import PropTypes from 'prop-types';

const InteractionItem = ({
    item,
    fetchData,
    editItem
}) => {

    const deleteUrl = '/api/interactions/delete/' + item.id;

    function deleteItem() {
        postData(deleteUrl, null, () => {
            fetchData();
            window.dispatchEvent(new Event('updateChangeLog'));
        });
    }

    return (
        <tr>
            <CustomTd content={formatter.date(item.date)} />
            <CustomTd className="text-pre-wrap" content={item.description} />
            <CustomTd hide="md" content={item.userInitials} />
            <CustomTd className="button-cell">
                <EditDeleteButton
                    deleteItem={deleteItem}
                    editItem={editItem}
                    viewItem={editItem}
                    showText={false}
                    acl={item.acl}
                />
            </CustomTd>
        </tr>
    );
}

InteractionItem.propTypes = {
    deleteUrl: PropTypes.string,
    editItem: PropTypes.func,
    fetchData: PropTypes.func
};

export default InteractionItem;